import { Station } from '../../../integrated-client/models/Station';

export type StationsList = Array<Station>;

export class ResultsData {

  items: StationsList
  showMore: boolean
  total?: number

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}